import { Modifier } from '../modifier';
import type { Technique } from '../techniques.type';
import { techniqueHistory } from '../../../store';
import type { Die } from '../die.type';
import type { Player } from '../player.type';
import { DieFace } from '../face.type';
import { SoundType } from '../../components/audio.svelte';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Slow extends Modifier {
  static readonly baseTitle = 'Slow';
  static readonly baseText =
    'Gives technique "Catch Up" which must be used between actions. Stable.';
  static readonly baseIcon = 'slow';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Last;

  // Instance properties that can change
  title = Slow.baseTitle;
  text = Slow.baseText;
  icon = Slow.baseIcon;
  tags: Array<ModifierTags> = [...Slow.baseTags];
  priority = Slow.basePriority;

  getTechniques(techniques: Technique[]): Technique[] {
    const lastAction = techniqueHistory[0];
    if (lastAction && lastAction.title != 'Catch Up') {
      techniques.length = 0;
    }

    return [
      {
        title: 'Catch Up',
        text: 'Do Nothing.',
        tags: ['chain', 'required'],
        ingredients: [DieFace.Blank],
        requirements: [
          {
            text: 'Previous technique was not a "Catch Up" technique.',
            icon: 'blank',
            test: (source: Player, target: Player) => {
              const lastAction = techniqueHistory[0];
              if (!lastAction) return false;
              return lastAction.title != 'Catch Up';
            },
          },
        ],
        audio: SoundType.None,
        activate: (target: Player, source: Player, dice: Array<Die>) => {},
      },
    ];
  }

  update(stacks: number, params: ModifierParams) {
    super.update(stacks, params);
    this.delay = true;
  }

  startTurn() {
    if (this.delay) {
      const distracted = this.owner.statusEffects.find(
        (modifier) => modifier.type === StatusEffect.Distracted,
      );
      if (!distracted) {
        this.delay = false;
      }
    }
  }

  endTurn() {
    if (!this.delay) {
      this.removeStacks(1);
    }
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Slow, Slow);
